import React from "react";

const BoldArrowDownIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_6604_2451)">
      <path
        d="M15.1665 5.2491C15.1665 5.14959 15.1368 5.05236 15.0812 4.96983C15.0256 4.8873 14.9466 4.82324 14.8544 4.78584C14.7622 4.74844 14.6609 4.7394 14.5635 4.75988C14.4662 4.78035 14.3771 4.82942 14.3078 4.90079L8.1613 11.0473L2.01481 4.90079C1.96874 4.85281 1.91355 4.8145 1.85249 4.78811C1.79142 4.76171 1.72571 4.74777 1.65919 4.7471C1.59267 4.74642 1.52668 4.75902 1.4651 4.78417C1.40351 4.80931 1.34756 4.84649 1.30052 4.89353C1.25348 4.94057 1.2163 4.99652 1.19115 5.05811C1.16601 5.1197 1.15341 5.18568 1.15408 5.2522C1.15476 5.31872 1.1687 5.38444 1.19509 5.4455C1.22148 5.50657 1.25979 5.56175 1.30778 5.60782L7.80778 12.1078C7.90155 12.2016 8.02871 12.2542 8.1613 12.2542C8.29388 12.2542 8.42104 12.2016 8.51481 12.1078L15.0148 5.60782C15.0628 5.56122 15.101 5.50546 15.127 5.44384C15.1531 5.38222 15.1665 5.316 15.1665 5.2491Z"
        fill="#232D3B"
        stroke="#232D3B"
        strokeWidth="0.7"
      />
    </g>
    <defs>
      <clipPath id="clip0_6604_2451">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(0.5 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default BoldArrowDownIcon;
